import { render, staticRenderFns } from "./SplitRevenueField.vue?vue&type=template&id=6ca9a6ea&scoped=true"
import script from "./SplitRevenueField.vue?vue&type=script&lang=ts"
export * from "./SplitRevenueField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ca9a6ea",
  null
  
)

export default component.exports